import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { VendorConversationTeamMemberV1 } from '../../../../api/api/models/vendor-conversation-team-member-v1'
import { VendorConversationTeamV1 } from '../../../../api/api/models/vendor-conversation-team-v1'

import * as convTeamActions from '../actions/conversation-team.actions'

export const MY_WORK_ID = -1

export interface VendorConversationTeamExtended extends VendorConversationTeamV1 {
  newMessage: boolean
}

export interface State extends EntityState<VendorConversationTeamExtended> {
  switchedTeamId: number
}

export const adapter: EntityAdapter<VendorConversationTeamExtended> = createEntityAdapter<VendorConversationTeamExtended>({
  selectId: (team: VendorConversationTeamExtended) => team.id,
  sortComparer: false
})

export const initialState: State = adapter.getInitialState({
  switchedTeamId: MY_WORK_ID,
})

const updateTeams = (state: State, team: VendorConversationTeamExtended, incDec: number, count?: number) => {
  return adapter.updateOne({
    id: team.id,
    changes: {
      ...team,
      conversations: {
        ...team.conversations,
        count: (typeof count === 'number') ? count : team.conversations.count + incDec
      }
    }
  }, state)
}

export function reducer(state = initialState, action: convTeamActions.ConversationTeamActions): State {
  switch (action.type) {

    case convTeamActions.LOAD_CONVERSATION_TEAMS_SUCCESS: {
      const me = {
        id: MY_WORK_ID,
        name: 'My Work',
        conversations: {
          count: action.payload.me ? action.payload.me.conversations.count : 0
        },
        imgUrl: '',
        newMessage: false,
      }
      return adapter.addAll([me, ...action.payload.teams.map(t => ({...t, newMessage: false}))], state)
    }

    case convTeamActions.LOAD_CONVERSATION_TEAM_SUCCESS: {
      return adapter.addOne({...action.payload.team, newMessage: false}, state)
    }

    case convTeamActions.REMOVE_CONVERSATION_TEAM: {
      return adapter.removeOne(action.payload.vendorTeamId, state)
    }

    case convTeamActions.REMOVE_TEAM_MEMBER: {
      const {vendorTeamId, vendorUserId} = action.payload
      const team = state.entities[vendorTeamId]
      if (!team) {
        return state
      }

      const items = team.teamMembers.items.filter(i => i.vendorUserId !== vendorUserId)
      return adapter.updateOne({
        id: vendorTeamId,
        changes: {
          ...team,
          teamMembers: {
            ...team.teamMembers,
            items,
          }
        }
      }, state)
    }

    case convTeamActions.SWITCH_TEAM: {
      return {
        ...state,
        switchedTeamId: +action.payload.vendorTeamId
      } as State
    }

    case convTeamActions.CONVERSATIONS_LOADED: {
      const {count, vendorTeamId, open} = action.payload
      const team = state.entities[vendorTeamId]
      if (!open || !team) {
        return state
      }
      return updateTeams(state, team, 0, count)
    }

    case convTeamActions.INCREMENT_CONVERSATIONS: {
      const {vendorTeamId} = action.payload
      const team = state.entities[vendorTeamId]
      if (!team) {
        return state
      }
      return updateTeams(state, team, 1)
    }

    case convTeamActions.DECREMENT_CONVERSATIONS: {
      const {vendorTeamId} = action.payload
      const team = state.entities[vendorTeamId]
      if (!team) {
        return state
      }
      return updateTeams(state, team, -1)
    }

    case convTeamActions.NEW_MESSAGE: {
      const {vendorTeamId, newMessage} = action.payload
      return adapter.updateOne({id: vendorTeamId, changes: {newMessage}}, state)
    }

    case convTeamActions.UPDATE_ASSIGNED_CONVERSATION_TO_TEAM_MEMBER: {
      const {vendorTeamId, vendorUserId, increment} = action.payload
      const team = state.entities[vendorTeamId]
      if (!team || !team.teamMembers) {
        return state
      }

      const memberId = team.teamMembers.items.findIndex((m: VendorConversationTeamMemberV1) => m.vendorUserId === vendorUserId)
      if (memberId === -1) {
        return state
      }
      const items = [...team.teamMembers.items]
      const member = items[memberId]
      member.conversationCount = increment
        ? member.conversationCount + 1
        : Math.max(member.conversationCount - 1, 0)


      return adapter.updateOne({
        id: vendorTeamId,
        changes: {
          ...team,
          teamMembers: {
            ...team.teamMembers,
            items,
          }
        }
      }, state)
    }

    default:
      return state
  }
}

export const getSwitchedTeamId = (state: State) => +state.switchedTeamId



// WEBPACK FOOTER //
// ./src/app/shared/team/store/reducers/conversation-team.reducer.ts